// extracted by mini-css-extract-plugin
export var actions = "_15-0";
export var actionsContainer = "_15-7";
export var border = "_15-1";
export var childFullHeight = "_15-f";
export var collapse = "_15-2";
export var content = "_15-a";
export var contentChild = "_15-e";
export var fullscreen = "_15-c";
export var hasLeftRadius = "_15-k";
export var headerContainer = "_15-3";
export var headerRow = "_15-5";
export var hidePadding = "_15-b";
export var navCollapsedGap = "_15-l";
export var noScrollX = "_15-m";
export var noScrollY = "_15-n";
export var noTopPadding = "_15-i";
export var optOutTopPadding = "_15-d";
export var pageMain = "_15-j";
export var pageOuter = "_15-g";
export var pagePadding = "_15-8";
export var pageScroll = "_15-9";
export var profile = "_15-o";
export var profileContainer = "_15-p";
export var profileImage = "_15-q";
export var profileMain = "_15-r";
export var profileSubtitle = "_15-t";
export var profileTitle = "_15-s";
export var showLeftPadding = "_15-h";
export var tabsPortalSlot = "_15-6";
export var tabsWrapper = "_15-4";
export var title = "_15-u";